// extracted by mini-css-extract-plugin
module.exports = {"cardLive":"styles_cardLive__6Yeuo","cardLiveBox":"styles_cardLiveBox__LJEs4","cardLiveOverlay":"styles_cardLiveOverlay__xbL3h","cardLiveBoxLabel":"styles_cardLiveBoxLabel__wHWyh"};